import React from 'react';

import { Checkbox } from 'antd';

import ProjectEventSummary from '@components/Project/ProjectEventSummary';

const ProjectPrintEventItem = ({ checked, event, onChange, type }) => {
    return (
        <Checkbox checked={checked} onChange={onChange}>
            <ProjectEventSummary event={event} type={type} />
        </Checkbox>
    );
};

export default ProjectPrintEventItem;
